<div class="environment">
  <div class="environment__info">{{ message }}</div>
</div>
